module.exports = "https://d3r7nsslvs6aaf.cloudfront.net/frontend/0ecb4b706ddbe1c9eab0c2c006901629.svg";